@if (recipesCard?.length > 0) {
  <sd-component-wrapper
    [content]="wrapperContent"
    [themesConfig]="lameConfig?.recipes?.backgroundTheme"
  >
    @if (recipesCard?.length > 0) {
      <div sd-component-wrapper-component>
        <wc-base-list-recipe [recipeCards]="recipesCard" [totalCount]="totalCount" [brandCorner]="brand" />
      </div>
    }
  </sd-component-wrapper>
}
